import { computed, onUnmounted, type Ref } from "vue";
import type { LocationQueryValue } from "vue-router";
import type { ExcursionRules } from "../types/configurator";
import { useExcursions } from "./useExcursions";

const EXCURSION_LOADING_KEY: string = "excursions";

interface ConfiguratorProps {
  application: Ref<Record<string, any>>;
}

interface Configurator {
  excursionRules: Readonly<Ref<ExcursionRules>>;
  selectedExcursionIds: Ref<string[] | LocationQueryValue[]>;
  excursionsStepIsComplete: () => boolean;
  isLoading: Ref<boolean>;
  hasErrors: Ref<boolean>;
  errors: Ref<Error[]>;
}

export const useConfigurator = (props: ConfiguratorProps): Configurator => {
  const {
    excursionRules,
    selectedExcursionIds,
    excursionsStepIsComplete,
    isLoading: isExcursionLoading,
    hasErrors: hasExcursionErrors,
    errors: excursionErrors,
  } = useExcursions(props.application.value.session);

  const isLoading = computed(() => isExcursionLoading.value);
  const errors = computed(() => excursionErrors.value);
  const hasErrors = computed(() => hasExcursionErrors.value);

  props.application.value.registerLoadingState(EXCURSION_LOADING_KEY, isExcursionLoading, excursionErrors);

  const unloadRegisteredLoaders = () => {
    props.application.value.removeLoadingState(EXCURSION_LOADING_KEY);
  };

  onUnmounted(() => {
    unloadRegisteredLoaders();
  });

  return {
    excursionRules,
    selectedExcursionIds,
    excursionsStepIsComplete,
    isLoading,
    hasErrors,
    errors,
  };
};
